import { labelDefaultSemiboldStyles } from '@lifebit-ai/lds'
import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.size.space['03']};
  padding: 0;
  width: 100%;
`

export const TabsRow = styled.div`
  border-bottom: none;
  display: flex;

  > div[role='tablist'] {
    border-bottom: none;
    margin-bottom: 0;
  }

  button[role='tab'] {
    ${labelDefaultSemiboldStyles};
    color: ${({ theme }) => theme.color.content.main};
  }
`
